import { render, staticRenderFns } from "./Deu.vue?vue&type=template&id=2f18cc09&scoped=true"
import script from "./Deu.vue?vue&type=script&lang=js"
export * from "./Deu.vue?vue&type=script&lang=js"
import style0 from "./Deu.vue?vue&type=style&index=0&id=2f18cc09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f18cc09",
  null
  
)

export default component.exports